export const MAX_CHARS = {
  EMAIL: 150,
  FULLNAME: 150,
  PHONE: 150,
  COMMENTS: 500,
  CUSTOM: 150,
}

export const MIN_CHARS = {
  EMAIL: 4,
  FULLNAME: 1,
  PHONE: 6,
  COMMENTS: 1,
  CUSTOM: 1,
}
